// PLAN2 WP39 — track(): a fire-and-forget sendBeacon to /e with the CSRF token (WP10's token, read from the root loader
// data by the caller). Refuses silently without consent or with GPC. Props outside the event's closed list are dropped.
import catalogue from "~/config/analytics-events.json";

export type AnalyticsEvent = keyof typeof catalogue.events;
const VALUE = /^[a-z0-9._:-]{1,64}$/;

export function consentGiven(cookie: string, gpc: boolean): boolean {
  if (gpc) return false;
  return /(?:^|;\s*)ps_consent=analytics:1(?:;|$)/.test(cookie);
}

export function cleanProps(event: AnalyticsEvent, props: Record<string, unknown>): Record<string, string> {
  const allowed = catalogue.events[event] as readonly string[];
  const out: Record<string, string> = {};
  for (const k of allowed) {
    const v = props[k];
    if (typeof v === "string" && VALUE.test(v)) out[k] = v;
  }
  return out;
}

export function track(event: AnalyticsEvent, props: Record<string, unknown>, csrf: string): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined" || !navigator.sendBeacon) return false;
  const gpc = (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl === true;
  if (!consentGiven(document.cookie, gpc)) return false;
  const form = new FormData();
  form.set("csrf", csrf);
  form.set("event", event);
  form.set("props", JSON.stringify(cleanProps(event, props)));
  return navigator.sendBeacon("/e", form);
}
